import * as React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

export const FooterConnector = () => (
  <Footer style={{ textAlign: 'center' }}>
    BakBak - 24 hours
  </Footer>
);


// WEBPACK FOOTER //
// ./src/modules/layout/footer/FooterConnector.tsx